import * as React from 'react'

import { cn } from '~/client/src/shared/utils/cn'

import { ObjectReferenceSize } from './ObjectReference'

// The second line hangs under the name, not under the glyph, so it indents by the icon
// box plus the gap to its right. `dense` is 16 + 8; every other rung keeps BASE's 4px.
const SECOND_LINE_INDENT_CLASS: Record<ObjectReferenceSize, string> = {
  md: 'tw:pl-6',
  sm: 'tw:pl-[22px]',
  xs: 'tw:pl-5',
  xxs: 'tw:pl-[18px]',
  dense: 'tw:pl-6',
}

interface IProps {
  /** A non-`link` ObjectReference: a link's Button padding would misalign the lines. */
  reference: React.ReactElement
  size: ObjectReferenceSize
  secondLine?: string | null
}

/** An ObjectReference with a muted second line under its name. */
export const StackedReference: React.FC<IProps> = ({
  reference,
  size,
  secondLine,
}) => {
  if (!secondLine) return reference

  // One truncating line rather than a node per segment: a line that outgrows its column
  // then takes a single ellipsis at the end, and `title` still carries all of it.
  return (
    <span className="tw:flex tw:flex-col tw:min-w-0 tw:max-w-full">
      {reference}
      <span
        className={cn(
          'tw:truncate tw:text-app-micro tw:text-muted-foreground',
          SECOND_LINE_INDENT_CLASS[size],
        )}
        title={secondLine}
      >
        {secondLine}
      </span>
    </span>
  )
}
